import { render, staticRenderFns } from "./ClaimsFilter.vue?vue&type=template&id=9d502b4c"
import script from "./ClaimsFilter.vue?vue&type=script&lang=js"
export * from "./ClaimsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports